import React, { PureComponent } from 'react';
import {
    Text,
    View,
    StyleSheet
} from 'react-native';

import {
    JDImage,
    JDTouchable,
    JDShare
} from '@jdreact/jdreact-core-lib'
import { px, pt, share } from '../common/utils';
let img = {
    share: require('../img/share.png')
}
class Share extends PureComponent {
    constructor(props) {
        super(props);
        this.shareFn = this.shareFn.bind(this)
    };

    render() {

        return (
            <JDTouchable onPress={this.shareFn} >
                <View style={[st.con, this.props.style]}>
                    <JDImage style={st.img} source={img.share}></JDImage>
                </View>
            </JDTouchable>
        )
    }

    shareFn() {
        const { shareInfo } = this.props

        let url = shareInfo.url || 'https://pro.m.jd.com/mall/active/2Hbfrq8NQumAZFDB8NnbKFrrNh1J/index.html';
        let title = shareInfo.title || '京东电影票 热映大片选座购票';
        let msg = shareInfo.msg || '看电影，上京东！看热映影片预告片，在线选座立即购票！';
        let logo = shareInfo.logo || 'https://storage.jd.com/ltmovie/movieLogo.jpg';
        let name = shareInfo.name || 'movie';

        JDShare.showShareDialog(url, title, msg, logo, name).then((response) => {
            console.log('success');
        }, (error) => {
            console.log('error');
        });
    }
}
const st = StyleSheet.create({
    con: {
        flexWrap: 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        width: pt(44),
        height: pt(44),
    },
    img: {
        height: pt(16),
        width: pt(16),
        resizeMode: 'contain'
    }
});

export default Share;